import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { ActionIcon, Text } from '@mantine/core';
import { IconCheck, IconPlayerPause, IconPlayerPlay, IconX } from '@tabler/icons-react';
import TestsApi from "../../api/TestsApi";
import { notifications } from '@mantine/notifications';
import { modals } from '@mantine/modals';

export function PauseResume({ selectedMemberWebsite, pageId, taguchiTestId, TestStatusShow, systemUsageLoader }:any) {
  const navigate = useNavigate();
  const [, setIsTestPaused] = useState(false);
  const [testPauseResumeTitle, setTestPauseResumeTitle] = useState('Pause Test');
  const [testPauseResumeIcon, setTestPauseResumeIcon] = useState(<IconPlayerPause size="1.1rem" />);
  
  const handlePauseResumeTest = (value:any) => {
    const isPause = testPauseResumeTitle === 'Pause Test';
    const action = isPause ? 'Pause' : 'Resume';

    modals.openConfirmModal({
      trapFocus: false,
      title: `${testPauseResumeTitle}`,
      children: (
        <Text size="sm">
          {isPause ? (
            <>
              Pausing disrupts traffic allocation and can delay or interrupt winner detection.
              <br /><br />
              Would you like to continue?
            </>
          ) : (
            `Are you sure you want to ${action} this test?`
          )}
        </Text>
      ),
      labels: { confirm: action, cancel: "Cancel" },
      confirmProps: { color: isPause ? 'yellow' : 'blue' },
      onCancel: () => console.log('Cancel'),
      onConfirm: () => {
        handleConfirmPauseResumeTest();
        setTestPauseResumeTitle(isPause ? 'Resume Test' : 'Pause Test');
      },
    });
  };

  const handleConfirmPauseResumeTest = () => {
    if (!pageId) {
      navigate('/review-tests');
      return;
    }
    systemUsageLoader(true);
    TestsApi.pauseresumetest({
      system_website_id: selectedMemberWebsite,
      page_id:pageId,
      taguchi_id:taguchiTestId
    })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          navigate("/logout");
        }
      }
    })
    .then(data => {
      if (data.status === 1) {
        systemUsageLoader(false);
        const newStatus = data.data.teststatus;
        setIsTestPaused(newStatus === 'pause');
        setTestPauseResumeTitle(newStatus === 'pause' ? 'Resume Test' : 'Pause Test');
        setTestPauseResumeIcon(
          newStatus === 'pause' ? (
            <IconPlayerPlay size="1.1rem" />
          ) : (
            <IconPlayerPause size="1.1rem" />
          )
        );
        notifications.show({
          color: 'green',
          icon: <IconCheck size="1.1rem" />,
          title: 'Success',
          message: data.message,
        });
      } else {
        notifications.show({
          color: 'red',
          icon: <IconX size="1.1rem" />,
          title: 'Error',
          message: data.message,
        });
        systemUsageLoader(false);
      }
    })
    .catch(error => {
      systemUsageLoader(false);
      console.error("API Error:", error);
    });
  };

  useEffect(() => {
    if(TestStatusShow){
      setIsTestPaused(TestStatusShow === 'pause');
      setTestPauseResumeTitle(TestStatusShow === 'pause' ? 'Resume Test' : 'Pause Test');
      setTestPauseResumeIcon(
        TestStatusShow === 'pause' ? (
          <IconPlayerPlay size="1.1rem" />
        ) : (
          <IconPlayerPause size="1.1rem" />
        )
      );
    }
  }, [TestStatusShow]);

  return (
    <>
      <ActionIcon
        variant="default"
        size="lg"
        sx={(theme) => ({
          backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[5] : '#fff',
        })}
        title={testPauseResumeTitle}
        ml={5}
        onClick={handlePauseResumeTest}
      >
        {testPauseResumeIcon}
      </ActionIcon>
    </>
  );
}